module.exports = __webpack_public_path__ + "static/media/1525542_196120943925013_1249200976_n.6432b32c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/makeup_hair/1525542_196120943925013_1249200976_n.jpg
// module id = 345
// module chunks = 0